import { useData, withDefault } from "@faedev/editor-utils";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import validateAuthToken from "src/functions/validateAuthToken";

function getData(
  endpoint?: string | null | undefined,
  slug?: string | null | undefined,
  lang?: string | null | undefined,
  skipAuth?: boolean | null | undefined,
  refresh?: boolean | null | undefined,
  limit?: number | null | undefined
) {
  let headers = {};
  if (!skipAuth && skipAuth !== undefined) {
    const cookieOrderId = getCookieByName(`orderId`);
    const isAuthorized = validateAuthToken(
      getCookieByName(`auth-token`),
      cookieOrderId
        ? {
            "Cookie-Order-Id": cookieOrderId,
          }
        : null,
      true
    );
    if (isAuthorized) {
      headers = { headers: isAuthorized };
    }
  }

  let url = new URL(`${constants.Paths.apiUrl}/${endpoint}/${slug}`);
  let params = new URLSearchParams();
  !slug &&
    params.append(
      "_limit",
      limit ? limit.toString() : String(constants.Api.fetchDefaultLimit)
    );
  url.search = params.toString();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useData(
    () =>
      fetch(url, {
        method: "GET",
        ...headers,
      }).then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("API Error");
        }
      }),
    {
      _locale: withDefault(lang, constants.Locales._default.lang),
      refresh: refresh,
    }
  );
}

export default getData;
